@if ((corporateTaxEntity$ | async) && (vpbBerekening$ | async)) {
  <form [formGroup]="balansEnResultatenRekeningFg" style="max-width: 80%">
    <div class="row">
      <div class="col col-1 pt-3">
        <p>Netto omzet</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-4">
        <div class="col-2" formGroupName="nettoOmzet">
          @for (item of getArrayControls('nettoOmzet'); track item; let j = $index) {
            <div [formGroupName]="j">
              <snelstart-ui-number-form-control
                [disabledControl]="isFE"
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150"
                formControlName="bedrag"
                label="Bedrag"
                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col col-1">
        <p>Mutatie voorraden en onderhanden werk</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-4">
        <div class="col-2" formGroupName="wijzigingOnderhandenWerk">
          @for (item of getArrayControls('wijzigingOnderhandenWerk'); track item; let j = $index) {
            <div [formGroupName]="j">
              <snelstart-ui-number-form-control
                [disabledControl]="isFE"
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150"
                formControlName="bedrag"
                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col col-1">
        <p>Overige opbrengsten</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-4">
        <div class="col-2" formGroupName="overigeOpbrengsten">
          @for (item of getArrayControls('overigeOpbrengsten'); track item; let j = $index) {
            <div [formGroupName]="j">
              <snelstart-ui-number-form-control
                [disabledControl]="isFE"
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150"
                formControlName="bedrag"
                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="row" style="">
      <div class="col col-1 pt-3">
        <p>Inkoopwaarde verkopen</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div class="col-2" formGroupName="inkoopwaardeVerkopen">
          @for (item of getArrayControls('inkoopwaardeVerkopen'); track item; let j = $index) {
            <div [formGroupName]="j">
              <snelstart-ui-number-form-control
                [disabledControl]="isFE"
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150"
                formControlName="bedrag"
                label="Bedrag"
                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
          }
        </div>
      </div>
      <div class="col-4">
        <div style="height: 20px; width: 160px"></div>
      </div>
    </div>

    <div class="row" style="">
      <div class="col col-1">
        <p>Uitbesteed werk en andere externe kosten</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div class="col-2" formGroupName="kostenUitbesteedWerk">
          @for (item of getArrayControls('kostenUitbesteedWerk'); track item; let j = $index) {
            <div [formGroupName]="j">
              <snelstart-ui-number-form-control
                [disabledControl]="isFE"
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150"
                formControlName="bedrag"
                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
          }
        </div>
      </div>
      <div class="col-4">
        <div style="height: 20px; width: 160px"></div>
      </div>
    </div>

    <div class="pt-3">
      <div class="row" style="">
        <div class="col col-1">
          <p>Lonen en salarissen</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="lonenEnSalarissen">
            @for (item of getArrayControls('lonenEnSalarissen'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>

      <div class="row" style="">
        <div class="col col-1">
          <p>Sociale lasten</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="socialeLasten">
            @for (item of getArrayControls('socialeLasten'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>

      <div class="row" style="">
        <div class="col col-1">
          <p>Pensioenlasten</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="pensioenLasten">
            @for (item of getArrayControls('pensioenLasten'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>

      <div class="row" style="">
        <div class="col col-1">
          <p>Overige personeelskosten</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="overigePersoneelskosten">
            @for (item of getArrayControls('overigePersoneelskosten'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>

      <div class="row" style="">
        <div class="col col-1">
          <p>Af: Ontvangen vergoedingen en subsidies</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="ontvangenVergoedingenEnSubsidies">
            @for (item of getArrayControls('ontvangenVergoedingenEnSubsidies'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€ -"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>
    </div>

    <div class="pt-3">
      <div class="row" style="">
        <div class="col col-1">
          <p>Afschrijving goodwill</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="afschrijvingenGoodwill">
            @for (item of getArrayControls('afschrijvingenGoodwill'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>

      <div class="row" style="">
        <div class="col col-1">
          <p>Afschrijving overige immateriële vaste activa</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="afschrijvingOverigeImmaterieleActiva">
            @for (item of getArrayControls('afschrijvingOverigeImmaterieleActiva'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>
    </div>

    <div class="row" style="">
      <div class="col col-1">
        <p>Afschrijving gebouwen en terreinen</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div class="col-2" formGroupName="afschrijvingenGebouwen">
          @for (item of getArrayControls('afschrijvingenGebouwen'); track item; let j = $index) {
            <div [formGroupName]="j">
              <snelstart-ui-number-form-control
                [disabledControl]="isFE"
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150"
                formControlName="bedrag"
                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
          }
        </div>
      </div>
      <div class="col-4">
        <div style="height: 20px; width: 160px"></div>
      </div>
    </div>

    <div class="row" style="">
      <div class="col col-1">
        <p>Afschrijving machines en installaties</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div class="col-2" formGroupName="afschrijvingenMachines">
          @for (item of getArrayControls('afschrijvingenMachines'); track item; let j = $index) {
            <div [formGroupName]="j">
              <snelstart-ui-number-form-control
                [disabledControl]="isFE"
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150"
                formControlName="bedrag"
                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
          }
        </div>
      </div>
      <div class="col-4">
        <div style="height: 20px; width: 160px"></div>
      </div>
    </div>

    <div class="row" style="">
      <div class="col col-1">
        <p>Afschrijving andere vaste activa</p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div class="col-2" formGroupName="afschrijvingenOverig">
          @for (item of getArrayControls('afschrijvingenOverig'); track item; let j = $index) {
            <div [formGroupName]="j">
              <snelstart-ui-number-form-control
                [disabledControl]="isFE"
                [showAllDecimals]="false"
                align="right"
                class="custom-input-150"
                formControlName="bedrag"
                prefix="€"
              >
              </snelstart-ui-number-form-control>
            </div>
          }
        </div>
      </div>
      <div class="col-4">
        <div style="height: 20px; width: 160px"></div>
      </div>
    </div>

    <div class="pt-3">
      <div class="row" style="">
        <div class="col col-1">
          <p>Auto- en transportkosten</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="autoEnTransportKosten">
            @for (item of getArrayControls('autoEnTransportKosten'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>

      <div class="row" style="">
        <div class="col col-1">
          <p>Huisvestingskosten</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="huisvestingsKosten">
            @for (item of getArrayControls('huisvestingsKosten'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>

      <div class="row" style="">
        <div class="col col-1">
          <p>Onderhoudskosten</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="onderhoudsKosten">
            @for (item of getArrayControls('onderhoudsKosten'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>

      <div class="row" style="">
        <div class="col col-1">
          <p>Verkoopkosten</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="verkoopKosten">
            @for (item of getArrayControls('verkoopKosten'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>

      <div class="row" style="">
        <div class="col col-1">
          <p>Overige kosten</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="overigeKosten">
            @for (item of getArrayControls('overigeKosten'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>
    </div>

    <div class="pt-3">
      <div class="row">
        <div class="col col-1">
          <p>Financiële baten</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="financieleBaten">
            @for (item of getArrayControls('financieleBaten'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>

      <div class="row" style="">
        <div class="col col-1">
          <p>Financiële lasten</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="financieleLasten">
            @for (item of getArrayControls('financieleLasten'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€ -"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>

      <div class="row" style="">
        <div class="col col-1">
          <p>Buitengewone baten</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="buitengewoneBaten">
            @for (item of getArrayControls('buitengewoneBaten'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>

      <div class="row" style="">
        <div class="col col-1">
          <p>Buitengewone lasten</p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="buitengewoneLasten">
            @for (item of getArrayControls('buitengewoneLasten'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€ -"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>

      <div class="row" style="">
        <div class="col col-1">
          <p>Resultaat deelnemingen <span
            snelstartUiTooltip="Vul een minteken in bij een negatief resultaat deelneming"> &#x24D8;</span>
          </p>
        </div>
        <div class="col-2">
          <div style="height: 20px; width: 160px"></div>
        </div>
        <div class="col-3">
          <div class="col-2" formGroupName="resultaatDeelnemingen">
            @for (item of getArrayControls('resultaatDeelnemingen'); track item; let j = $index) {
              <div [formGroupName]="j">
                <snelstart-ui-number-form-control
                  [disabledControl]="isFE"
                  [showAllDecimals]="false"
                  align="right"
                  class="custom-input-150"
                  formControlName="bedrag"
                  prefix="€"
                >
                </snelstart-ui-number-form-control>
              </div>
            }
          </div>
        </div>
        <div class="col-4">
          <div style="height: 20px; width: 160px"></div>
        </div>
      </div>
    </div>
  </form>

  <form [formGroup]="berekendeResultatenFg" style="max-width: 80%">
    <div class="row">
      <div class="col col-1 pt-3">
        <p><b>Fiscale winst</b></p>
      </div>
      <div class="col-2">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-3">
        <div style="height: 20px; width: 160px"></div>
      </div>
      <div class="col-4">
        <snelstart-ui-number-form-control [disabledControl]="true"
                                          [showAllDecimals]="false"
                                          align="right"
                                          class="custom-input-150 pt-3"
                                          formControlName="saldoFiscaleWinstberekening"
                                          prefix="€"
        >
        </snelstart-ui-number-form-control>
      </div>
    </div>
  </form>
}
